import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { IconButton } from "@material-ui/core";
import { AddCircleOutline } from "@material-ui/icons";
import adminService from "../../../Services/adminService";
import Swal from "sweetalert2";
import { Component } from "react";
import moment from "moment";

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

class SupportCard extends Component {
  state = {
    cardSupportCases: []
  };

  async componentDidMount() {
    const res = await adminService.getCardSupportCases(this.props.cardNum);
    if (res.success) {
      this.setState({ cardSupportCases: res.supportCases });
    }
  }

  render() {
    return (
      <Card className="width100">
        <CardContent>
          <div className="add-new-support mb-20">
            <IconButton onClick={this.addNewSupport}>
              <AddCircleOutline />
            </IconButton>
          </div>
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead style={{ background: `black` }}>
                <TableRow>
                  <StyledTableCell align="center">סיבת פניה</StyledTableCell>
                  <StyledTableCell align="center">סטטוס פניה</StyledTableCell>
                  <StyledTableCell align="center">מענה שלנו</StyledTableCell>
                  <StyledTableCell align="center">רמת שביעות הרצון</StyledTableCell>
                  <StyledTableCell align="center">הערות נוספות (חשוב)</StyledTableCell>
                  <StyledTableCell align="center">תאריך יצירה</StyledTableCell>
                  <StyledTableCell align="center">יוצר</StyledTableCell>
                  <StyledTableCell align="center">עדכון אחרון</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.cardSupportCases.map((row, i) => (
                  <StyledTableRow key={"Ddd" + i}>
                    <StyledTableCell align="center">
                      <textarea disabled>{row.supportReason}</textarea>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <b className="primary-color">{row.status}</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <textarea disabled>{row.ourCaseResponse}</textarea>
                    </StyledTableCell>
                    <StyledTableCell align="center">{row.satisfactionLevel}</StyledTableCell>
                    <StyledTableCell align="center">{row.extraComments}</StyledTableCell>
                    <StyledTableCell align="center">{moment(row.dateCreated).format("DD/MM/YYYY")}</StyledTableCell>
                    <StyledTableCell align="center">{adminService.translateAdminName(row.createdBy, row.dateCreated)}</StyledTableCell>
                    <StyledTableCell align="center">{moment(row.lastUpdate).format("DD/MM/YYYY")}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    );
  }

  addNewSupport = () => {
    Swal.fire({
      title: "הכנסה של פניה חדשה",
      input: "textarea",
      showCancelButton: true,
      cancelButtonText: "ביטול",
      confirmButtonText: "המשך",
      preConfirm: (supportReason) => {
        if (!supportReason || supportReason.length < 4) return Swal.showValidationMessage("יש להזין סיבת פניה");
      }
    }).then(async (result) => {
      if (result.value) {
        const res = await adminService.pushNewSupport(result.value, this.props.cardNum, this.props.officeName);
        if (res.success) {
          Swal.fire("בוצע", "הוכנסה תמיכה חדשה", "success");
          const cardSupportCases = [...this.state.cardSupportCases];
          cardSupportCases.push({
            cardNum: this.props.cardNum,
            supportReason: result.value,
            status: "OPEN_CASE",
            createdBy: "You",
            dateCreated: new Date()
          });

          this.setState({ cardSupportCases });
        }
      }
    });
  };
}

export default SupportCard;
